import { Component } from "react";

export class ScorecardPrintComponent extends Component {
  public render() {
    return <div id="scorecard-printable">{this.props.children}</div>;
  }
}
